import { render, staticRenderFns } from "./InputPassAuth.vue?vue&type=template&id=0b9b79ca&scoped=true&"
import script from "./InputPassAuth.vue?vue&type=script&lang=js&"
export * from "./InputPassAuth.vue?vue&type=script&lang=js&"
import style0 from "./InputPassAuth.vue?vue&type=style&index=0&id=0b9b79ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b79ca",
  null
  
)

export default component.exports